// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__tph7T","container":"styles_container__1K9lG"};